import { Continent } from '@app/enums/continent';

export enum Country {
  ABW = 'ABW',
  AFG = 'AFG',
  AGO = 'AGO',
  AIA = 'AIA',
  ALA = 'ALA',
  ALB = 'ALB',
  AND = 'AND',
  ARE = 'ARE',
  ARG = 'ARG',
  ARM = 'ARM',
  ASM = 'ASM',
  ATA = 'ATA',
  ATF = 'ATF',
  ATG = 'ATG',
  AUS = 'AUS',
  AUT = 'AUT',
  AZE = 'AZE',
  BDI = 'BDI',
  BEL = 'BEL',
  BEN = 'BEN',
  BES = 'BES',
  BFA = 'BFA',
  BGD = 'BGD',
  BGR = 'BGR',
  BHR = 'BHR',
  BHS = 'BHS',
  BIH = 'BIH',
  BLM = 'BLM',
  BLR = 'BLR',
  BLZ = 'BLZ',
  BMU = 'BMU',
  BOL = 'BOL',
  BRA = 'BRA',
  BRB = 'BRB',
  BRN = 'BRN',
  BTN = 'BTN',
  BVT = 'BVT',
  BWA = 'BWA',
  CAF = 'CAF',
  CAN = 'CAN',
  CCK = 'CCK',
  CHE = 'CHE',
  CHL = 'CHL',
  CHN = 'CHN',
  CIV = 'CIV',
  CMR = 'CMR',
  COD = 'COD',
  COG = 'COG',
  COK = 'COK',
  COL = 'COL',
  COM = 'COM',
  CPV = 'CPV',
  CRI = 'CRI',
  CUB = 'CUB',
  CUW = 'CUW',
  CXR = 'CXR',
  CYM = 'CYM',
  CYP = 'CYP',
  CZE = 'CZE',
  DEU = 'DEU',
  DJI = 'DJI',
  DMA = 'DMA',
  DNK = 'DNK',
  DOM = 'DOM',
  DZA = 'DZA',
  ECU = 'ECU',
  EGY = 'EGY',
  ERI = 'ERI',
  ESH = 'ESH',
  ESP = 'ESP',
  EST = 'EST',
  ETH = 'ETH',
  FIN = 'FIN',
  FJI = 'FJI',
  FLK = 'FLK',
  FRA = 'FRA',
  FRO = 'FRO',
  FSM = 'FSM',
  GAB = 'GAB',
  GBR = 'GBR',
  GEO = 'GEO',
  GGY = 'GGY',
  GHA = 'GHA',
  GIB = 'GIB',
  GIN = 'GIN',
  GLP = 'GLP',
  GMB = 'GMB',
  GNB = 'GNB',
  GNQ = 'GNQ',
  GRC = 'GRC',
  GRD = 'GRD',
  GRL = 'GRL',
  GTM = 'GTM',
  GUF = 'GUF',
  GUM = 'GUM',
  GUY = 'GUY',
  HKG = 'HKG',
  HMD = 'HMD',
  HND = 'HND',
  HRV = 'HRV',
  HTI = 'HTI',
  HUN = 'HUN',
  IDN = 'IDN',
  IMN = 'IMN',
  IND = 'IND',
  IOT = 'IOT',
  IRL = 'IRL',
  IRN = 'IRN',
  IRQ = 'IRQ',
  ISL = 'ISL',
  ISR = 'ISR',
  ITA = 'ITA',
  JAM = 'JAM',
  JEY = 'JEY',
  JOR = 'JOR',
  JPN = 'JPN',
  KAZ = 'KAZ',
  KEN = 'KEN',
  KGZ = 'KGZ',
  KHM = 'KHM',
  KIR = 'KIR',
  KNA = 'KNA',
  KOR = 'KOR',
  KWT = 'KWT',
  LAO = 'LAO',
  LBN = 'LBN',
  LBR = 'LBR',
  LBY = 'LBY',
  LCA = 'LCA',
  LIE = 'LIE',
  LKA = 'LKA',
  LSO = 'LSO',
  LTU = 'LTU',
  LUX = 'LUX',
  LVA = 'LVA',
  MAC = 'MAC',
  MAF = 'MAF',
  MAR = 'MAR',
  MCO = 'MCO',
  MDA = 'MDA',
  MDG = 'MDG',
  MDV = 'MDV',
  MEX = 'MEX',
  MHL = 'MHL',
  MKD = 'MKD',
  MLI = 'MLI',
  MLT = 'MLT',
  MMR = 'MMR',
  MNE = 'MNE',
  MNG = 'MNG',
  MNP = 'MNP',
  MOZ = 'MOZ',
  MRT = 'MRT',
  MSR = 'MSR',
  MTQ = 'MTQ',
  MUS = 'MUS',
  MWI = 'MWI',
  MYS = 'MYS',
  MYT = 'MYT',
  NAM = 'NAM',
  NCL = 'NCL',
  NER = 'NER',
  NFK = 'NFK',
  NGA = 'NGA',
  NIC = 'NIC',
  NIU = 'NIU',
  NLD = 'NLD',
  NOR = 'NOR',
  NPL = 'NPL',
  NRU = 'NRU',
  NZL = 'NZL',
  OMN = 'OMN',
  PAK = 'PAK',
  PAN = 'PAN',
  PCN = 'PCN',
  PER = 'PER',
  PHL = 'PHL',
  PLW = 'PLW',
  PNG = 'PNG',
  POL = 'POL',
  PRI = 'PRI',
  PRK = 'PRK',
  PRT = 'PRT',
  PRY = 'PRY',
  PSE = 'PSE',
  PYF = 'PYF',
  QAT = 'QAT',
  REU = 'REU',
  ROU = 'ROU',
  RUS = 'RUS',
  RWA = 'RWA',
  SAU = 'SAU',
  SDN = 'SDN',
  SEN = 'SEN',
  SGP = 'SGP',
  SGS = 'SGS',
  SHN = 'SHN',
  SJM = 'SJM',
  SLB = 'SLB',
  SLE = 'SLE',
  SLV = 'SLV',
  SMR = 'SMR',
  SOM = 'SOM',
  SPM = 'SPM',
  SRB = 'SRB',
  SSD = 'SSD',
  STP = 'STP',
  SUR = 'SUR',
  SVK = 'SVK',
  SVN = 'SVN',
  SWE = 'SWE',
  SXM = 'SXM',
  SYC = 'SYC',
  SYR = 'SYR',
  TCA = 'TCA',
  TCD = 'TCD',
  TGO = 'TGO',
  THA = 'THA',
  TJK = 'TJK',
  TKL = 'TKL',
  TKM = 'TKM',
  TLS = 'TLS',
  TON = 'TON',
  TTO = 'TTO',
  TUN = 'TUN',
  TUR = 'TUR',
  TUV = 'TUV',
  TWN = 'TWN',
  TZA = 'TZA',
  UGA = 'UGA',
  UKR = 'UKR',
  UMI = 'UMI',
  URY = 'URY',
  USA = 'USA',
  UZB = 'UZB',
  VAT = 'VAT',
  VCT = 'VCT',
  VEN = 'VEN',
  VGB = 'VGB',
  VIR = 'VIR',
  VNM = 'VNM',
  VUT = 'VUT',
  WLF = 'WLF',
  WSM = 'WSM',
  YEM = 'YEM',
  ZAF = 'ZAF',
  ZMB = 'ZMB',
  ZWE = 'ZWE',
  Unknown = 'Unknown',
}

export const CountryDescriptor = Object.freeze({
  [Country.ABW]: 'Aruba',
  [Country.AFG]: 'Afghanistan',
  [Country.AGO]: 'Angola',
  [Country.AIA]: 'Anguilla',
  [Country.ALA]: 'Aland Islands',
  [Country.ALB]: 'Albania',
  [Country.AND]: 'Andorra',
  [Country.ARE]: 'United Arab Emirates',
  [Country.ARG]: 'Argentina',
  [Country.ARM]: 'Armenia',
  [Country.ASM]: 'American Samoa',
  [Country.ATA]: 'Antarctica',
  [Country.ATF]: 'French Southern Territories',
  [Country.ATG]: 'Antigua and Barbuda',
  [Country.AUS]: 'Australia',
  [Country.AUT]: 'Austria',
  [Country.AZE]: 'Azerbaijan',
  [Country.BDI]: 'Burundi',
  [Country.BEL]: 'Belgium',
  [Country.BEN]: 'Benin',
  [Country.BES]: 'Bonaire, Sint Eustatius and Saba',
  [Country.BFA]: 'Burkina Faso',
  [Country.BGD]: 'Bangladesh',
  [Country.BGR]: 'Bulgaria',
  [Country.BHR]: 'Bahrain',
  [Country.BHS]: 'Bahamas',
  [Country.BIH]: 'Bosnia and Herzegovina',
  [Country.BLM]: 'Saint Barthélemy',
  [Country.BLR]: 'Belarus',
  [Country.BLZ]: 'Belize',
  [Country.BMU]: 'Bermuda',
  [Country.BOL]: 'Bolivia',
  [Country.BRA]: 'Brazil',
  [Country.BRB]: 'Barbados',
  [Country.BRN]: 'Brunei',
  [Country.BTN]: 'Bhutan',
  [Country.BVT]: 'Bouvet Island',
  [Country.BWA]: 'Botswana',
  [Country.CAF]: 'Central African Republic',
  [Country.CAN]: 'Canada',
  [Country.CCK]: 'Cocos (Keeling) Islands',
  [Country.CHE]: 'Switzerland',
  [Country.CHL]: 'Chile',
  [Country.CHN]: 'China',
  [Country.CIV]: 'Ivory Coast',
  [Country.CMR]: 'Cameroon',
  [Country.COD]: 'Congo (Democratic Republic)',
  [Country.COG]: 'Congo',
  [Country.COK]: 'Cook Islands',
  [Country.COL]: 'Colombia',
  [Country.COM]: 'Comoros',
  [Country.CPV]: 'Cape Verde',
  [Country.CRI]: 'Costa Rica',
  [Country.CUB]: 'Cuba',
  [Country.CUW]: 'Curaçao',
  [Country.CXR]: 'Christmas Island',
  [Country.CYM]: 'Cayman Islands',
  [Country.CYP]: 'Cyprus',
  [Country.CZE]: 'Czech Republic',
  [Country.DEU]: 'Germany',
  [Country.DJI]: 'Djibouti',
  [Country.DMA]: 'Dominica',
  [Country.DNK]: 'Denmark',
  [Country.DOM]: 'Dominican Republic',
  [Country.DZA]: 'Algeria',
  [Country.ECU]: 'Ecuador',
  [Country.EGY]: 'Egypt',
  [Country.ERI]: 'Eritrea',
  [Country.ESH]: 'Western Sahara',
  [Country.ESP]: 'Spain',
  [Country.EST]: 'Estonia',
  [Country.ETH]: 'Ethiopia',
  [Country.FIN]: 'Finland',
  [Country.FJI]: 'Fiji',
  [Country.FLK]: 'Falkland Islands',
  [Country.FRA]: 'France',
  [Country.FRO]: 'Faroe Islands',
  [Country.FSM]: 'Federated States of Micronesia',
  [Country.GAB]: 'Gabon',
  [Country.GBR]: 'United Kingdom',
  [Country.GEO]: 'Georgia',
  [Country.GGY]: 'Guernsey',
  [Country.GHA]: 'Ghana',
  [Country.GIB]: 'Gibraltar',
  [Country.GIN]: 'Guinea',
  [Country.GLP]: 'Guadeloupe',
  [Country.GMB]: 'Gambia',
  [Country.GNB]: 'Guinea-Bissau',
  [Country.GNQ]: 'Equatorial Guinea',
  [Country.GRC]: 'Greece',
  [Country.GRD]: 'Grenada',
  [Country.GRL]: 'Greenland',
  [Country.GTM]: 'Guatemala',
  [Country.GUF]: 'French Guiana',
  [Country.GUM]: 'Guam',
  [Country.GUY]: 'Guyana',
  [Country.HKG]: 'Hong Kong',
  [Country.HMD]: 'Heard Island and McDonald Islands',
  [Country.HND]: 'Honduras',
  [Country.HRV]: 'Croatia',
  [Country.HTI]: 'Haiti',
  [Country.HUN]: 'Hungary',
  [Country.IDN]: 'Indonesia',
  [Country.IMN]: 'Isle of Man',
  [Country.IND]: 'India',
  [Country.IOT]: 'British Indian Ocean Territory',
  [Country.IRL]: 'Ireland',
  [Country.IRN]: 'Iran',
  [Country.IRQ]: 'Iraq',
  [Country.ISL]: 'Iceland',
  [Country.ISR]: 'Israel',
  [Country.ITA]: 'Italy',
  [Country.JAM]: 'Jamaica',
  [Country.JEY]: 'Jersey',
  [Country.JOR]: 'Jordan',
  [Country.JPN]: 'Japan',
  [Country.KAZ]: 'Kazakhstan',
  [Country.KEN]: 'Kenya',
  [Country.KGZ]: 'Kyrgyzstan',
  [Country.KHM]: 'Cambodia',
  [Country.KIR]: 'Kiribati',
  [Country.KNA]: 'Saint Kitts and Nevis',
  [Country.KOR]: 'South Korea',
  [Country.KWT]: 'Kuwait',
  [Country.LAO]: 'Laos',
  [Country.LBN]: 'Lebanon',
  [Country.LBR]: 'Liberia',
  [Country.LBY]: 'Libya',
  [Country.LCA]: 'Saint Lucia',
  [Country.LIE]: 'Liechtenstein',
  [Country.LKA]: 'Sri Lanka',
  [Country.LSO]: 'Lesotho',
  [Country.LTU]: 'Lithuania',
  [Country.LUX]: 'Luxembourg',
  [Country.LVA]: 'Latvia',
  [Country.MAC]: 'Macau',
  [Country.MAF]: 'Saint Martin',
  [Country.MAR]: 'Morocco',
  [Country.MCO]: 'Monaco',
  [Country.MDA]: 'Moldova',
  [Country.MDG]: 'Madagascar',
  [Country.MDV]: 'Maldives',
  [Country.MEX]: 'Mexico',
  [Country.MHL]: 'Marshall Islands',
  [Country.MKD]: 'North Macedonia',
  [Country.MLI]: 'Mali',
  [Country.MLT]: 'Malta',
  [Country.MMR]: 'Myanmar',
  [Country.MNE]: 'Montenegro',
  [Country.MNG]: 'Mongolia',
  [Country.MNP]: 'Northern Mariana Islands',
  [Country.MOZ]: 'Mozambique',
  [Country.MRT]: 'Mauritania',
  [Country.MSR]: 'Montserrat',
  [Country.MTQ]: 'Martinique',
  [Country.MUS]: 'Mauritius',
  [Country.MWI]: 'Malawi',
  [Country.MYS]: 'Malaysia',
  [Country.MYT]: 'Mayotte',
  [Country.NAM]: 'Namibia',
  [Country.NCL]: 'New Caledonia',
  [Country.NER]: 'Niger',
  [Country.NFK]: 'Norfolk Island',
  [Country.NGA]: 'Nigeria',
  [Country.NIC]: 'Nicaragua',
  [Country.NIU]: 'Niue',
  [Country.NLD]: 'Netherlands',
  [Country.NOR]: 'Norway',
  [Country.NPL]: 'Nepal',
  [Country.NRU]: 'Nauru',
  [Country.NZL]: 'New Zealand',
  [Country.OMN]: 'Oman',
  [Country.PAK]: 'Pakistan',
  [Country.PAN]: 'Panama',
  [Country.PCN]: 'Pitcairn Islands',
  [Country.PER]: 'Peru',
  [Country.PHL]: 'Philippines',
  [Country.PLW]: 'Palau',
  [Country.PNG]: 'Papua New Guinea',
  [Country.POL]: 'Poland',
  [Country.PRI]: 'Puerto Rico',
  [Country.PRK]: 'North Korea',
  [Country.PRT]: 'Portugal',
  [Country.PRY]: 'Paraguay',
  [Country.PSE]: 'State of Palestine',
  [Country.PYF]: 'French Polynesia',
  [Country.QAT]: 'Qatar',
  [Country.REU]: 'Réunion',
  [Country.ROU]: 'Romania',
  [Country.RUS]: 'Russia',
  [Country.RWA]: 'Rwanda',
  [Country.SAU]: 'Saudi Arabia',
  [Country.SDN]: 'Sudan',
  [Country.SEN]: 'Senegal',
  [Country.SGP]: 'Singapore',
  [Country.SGS]: 'South Georgia and the South Sandwich Islands',
  [Country.SHN]: 'Saint Helena',
  [Country.SJM]: 'Svalbard and Jan Mayen',
  [Country.SLB]: 'Solomon Islands',
  [Country.SLE]: 'Sierra Leone',
  [Country.SLV]: 'El Salvador',
  [Country.SMR]: 'San Marino',
  [Country.SOM]: 'Somalia',
  [Country.SPM]: 'Saint Pierre and Miquelon',
  [Country.SRB]: 'Serbia',
  [Country.SSD]: 'South Sudan',
  [Country.STP]: 'São Tomé and Príncipe',
  [Country.SUR]: 'Suriname',
  [Country.SVK]: 'Slovakia',
  [Country.SVN]: 'Slovenia',
  [Country.SWE]: 'Sweden',
  [Country.SXM]: 'Sint Maarten',
  [Country.SYC]: 'Seychelles',
  [Country.SYR]: 'Syria',
  [Country.TCA]: 'Turks and Caicos Islands',
  [Country.TCD]: 'Chad',
  [Country.TGO]: 'Togo',
  [Country.THA]: 'Thailand',
  [Country.TJK]: 'Tajikistan',
  [Country.TKL]: 'Tokelau',
  [Country.TKM]: 'Turkmenistan',
  [Country.TLS]: 'Timor-Leste',
  [Country.TON]: 'Tonga',
  [Country.TTO]: 'Trinidad and Tobago',
  [Country.TUN]: 'Tunisia',
  [Country.TUR]: 'Turkey',
  [Country.TUV]: 'Tuvalu',
  [Country.TWN]: 'Taiwan',
  [Country.TZA]: 'Tanzania',
  [Country.UGA]: 'Uganda',
  [Country.UKR]: 'Ukraine',
  [Country.UMI]: 'United States Minor Outlying Islands',
  [Country.URY]: 'Uruguay',
  [Country.USA]: 'United States',
  [Country.UZB]: 'Uzbekistan',
  [Country.VAT]: 'Vatican City',
  [Country.VCT]: 'Saint Vincent and the Grenadines',
  [Country.VEN]: 'Venezuela',
  [Country.VGB]: 'British Virgin Islands',
  [Country.VIR]: 'U.S. Virgin Islands',
  [Country.VNM]: 'Vietnam',
  [Country.VUT]: 'Vanuatu',
  [Country.WLF]: 'Wallis and Futuna',
  [Country.WSM]: 'Samoa',
  [Country.YEM]: 'Yemen',
  [Country.ZAF]: 'South Africa',
  [Country.ZMB]: 'Zambia',
  [Country.ZWE]: 'Zimbabwe',
  [Country.Unknown]: 'Unknown',
});

export const CountriesByContinent: Record<Continent, Set<Country>> = {
  [Continent.Europe]: new Set([
    Country.ALB,
    Country.AND,
    Country.AUT,
    Country.BEL,
    Country.BIH,
    Country.BLR,
    Country.BGR,
    Country.CHE,
    Country.CZE,
    Country.DNK,
    Country.DEU,
    Country.ESP,
    Country.EST,
    Country.FIN,
    Country.FRA,
    Country.GBR,
    Country.GRC,
    Country.HRV,
    Country.HUN,
    Country.IRL,
    Country.ISL,
    Country.ITA,
    Country.LIE,
    Country.LTU,
    Country.LUX,
    Country.LVA,
    Country.MCO,
    Country.MDA,
    Country.MNE,
    Country.NLD,
    Country.NOR,
    Country.POL,
    Country.PRT,
    Country.ROU,
    Country.RUS,
    Country.SJM,
    Country.SRB,
    Country.SVK,
    Country.SVN,
    Country.SWE,
    Country.TUR,
    Country.UKR,
    Country.VAT,
    Country.ALA,
    Country.FRO,
    Country.GIB,
    Country.GGY,
    Country.JEY,
    Country.IMN,
    Country.MKD,
    Country.MLT,
    Country.SMR,
  ]),
  [Continent.Asia]: new Set([
    Country.AFG,
    Country.ARE,
    Country.ARM,
    Country.AZE,
    Country.BGD,
    Country.BTN,
    Country.BRN,
    Country.KHM,
    Country.CHN,
    Country.CYP,
    Country.GEO,
    Country.IND,
    Country.IDN,
    Country.IOT,
    Country.IRN,
    Country.IRQ,
    Country.ISR,
    Country.JPN,
    Country.JOR,
    Country.KAZ,
    Country.KOR,
    Country.KWT,
    Country.KGZ,
    Country.LAO,
    Country.LBN,
    Country.LKA,
    Country.MYS,
    Country.MDV,
    Country.MMR,
    Country.MNG,
    Country.NPL,
    Country.OMN,
    Country.PAK,
    Country.PHL,
    Country.PSE,
    Country.PRK,
    Country.QAT,
    Country.RUS,
    Country.SAU,
    Country.SGP,
    Country.SSD,
    Country.SYR,
    Country.THA,
    Country.TJK,
    Country.TKM,
    Country.TLS,
    Country.TWN,
    Country.UZB,
    Country.VNM,
    Country.BHR,
    Country.HKG,
    Country.MAC,
    Country.TUR,
    Country.YEM,
  ]),
  [Continent.Africa]: new Set([
    Country.DZA,
    Country.AGO,
    Country.BFA,
    Country.BDI,
    Country.BEN,
    Country.BWA,
    Country.CAF,
    Country.CMR,
    Country.COD,
    Country.COG,
    Country.COM,
    Country.CIV,
    Country.CPV,
    Country.DJI,
    Country.EGY,
    Country.ERI,
    Country.ESH,
    Country.ETH,
    Country.GAB,
    Country.GHA,
    Country.GIN,
    Country.GMB,
    Country.GNB,
    Country.GNQ,
    Country.KEN,
    Country.LBY,
    Country.LBR,
    Country.LSO,
    Country.MAR,
    Country.MDG,
    Country.MLI,
    Country.MOZ,
    Country.MRT,
    Country.MUS,
    Country.MWI,
    Country.MYT,
    Country.NAM,
    Country.NER,
    Country.NGA,
    Country.RWA,
    Country.SEN,
    Country.SLE,
    Country.SOM,
    Country.SYC,
    Country.ZAF,
    Country.ZMB,
    Country.ZWE,
    Country.REU,
    Country.SDN,
    Country.STP,
    Country.TZA,
    Country.TCD,
    Country.TGO,
    Country.TUN,
    Country.UGA,
  ]),
  [Continent.NorthAmerica]: new Set([
    Country.AIA,
    Country.ATG,
    Country.BHS,
    Country.BLM,
    Country.BLZ,
    Country.BMU,
    Country.BES,
    Country.BRB,
    Country.CAN,
    Country.CRI,
    Country.CUB,
    Country.CUW,
    Country.CYM,
    Country.DMA,
    Country.DOM,
    Country.GLP,
    Country.GRD,
    Country.GRL,
    Country.GTM,
    Country.HTI,
    Country.HND,
    Country.JAM,
    Country.KNA,
    Country.LCA,
    Country.MAF,
    Country.MEX,
    Country.MTQ,
    Country.NIC,
    Country.PAN,
    Country.PRI,
    Country.SHN,
    Country.SLV,
    Country.SXM,
    Country.TCA,
    Country.TTO,
    Country.USA,
    Country.VCT,
    Country.VGB,
    Country.VIR,
    Country.MSR,
  ]),
  [Continent.SouthAmerica]: new Set([
    Country.ARG,
    Country.ABW,
    Country.BOL,
    Country.BRA,
    Country.CHL,
    Country.COL,
    Country.ECU,
    Country.GUF,
    Country.GUY,
    Country.PRY,
    Country.PER,
    Country.SUR,
    Country.URY,
    Country.VEN,
    Country.FLK,
  ]),
  [Continent.Oceania]: new Set([
    Country.AUS,
    Country.CCK,
    Country.COK,
    Country.CXR,
    Country.FJI,
    Country.FSM,
    Country.GUM,
    Country.KIR,
    Country.MHL,
    Country.MNP,
    Country.NRU,
    Country.NCL,
    Country.NIU,
    Country.NZL,
    Country.PLW,
    Country.PNG,
    Country.PYF,
    Country.SPM,
    Country.SLB,
    Country.TON,
    Country.TUV,
    Country.VUT,
    Country.WLF,
    Country.ASM,
    Country.NFK,
    Country.PCN,
    Country.TKL,
    Country.UMI,
    Country.WSM,
  ]),
  [Continent.Antarctica]: new Set([Country.ATA, Country.ATF, Country.BVT, Country.HMD, Country.SGS]),
  [Continent.None]: new Set([Country.Unknown]),
};

export const CountryFlags = Object.freeze({
  [Country.ABW]: '🇦🇼',
  [Country.AFG]: '🇦🇫',
  [Country.AGO]: '🇦🇴',
  [Country.AIA]: '🇦🇮',
  [Country.ALA]: '🇦🇽',
  [Country.ALB]: '🇦🇱',
  [Country.AND]: '🇦🇩',
  [Country.ARE]: '🇦🇪',
  [Country.ARG]: '🇦🇷',
  [Country.ARM]: '🇦🇲',
  [Country.ASM]: '🇦🇸',
  [Country.ATA]: '🇦🇶',
  [Country.ATF]: '🇹🇫',
  [Country.ATG]: '🇦🇬',
  [Country.AUS]: '🇦🇺',
  [Country.AUT]: '🇦🇹',
  [Country.AZE]: '🇦🇿',
  [Country.BDI]: '🇧🇮',
  [Country.BEL]: '🇧🇪',
  [Country.BEN]: '🇧🇯',
  [Country.BES]: '🇧🇶',
  [Country.BFA]: '🇧🇫',
  [Country.BGD]: '🇧🇩',
  [Country.BGR]: '🇧🇬',
  [Country.BHR]: '🇧🇭',
  [Country.BHS]: '🇧🇸',
  [Country.BIH]: '🇧🇦',
  [Country.BLM]: '🇧🇱',
  [Country.BLR]: '🇧🇾',
  [Country.BLZ]: '🇧🇿',
  [Country.BMU]: '🇧🇲',
  [Country.BOL]: '🇧🇴',
  [Country.BRA]: '🇧🇷',
  [Country.BRB]: '🇧🇧',
  [Country.BRN]: '🇧🇳',
  [Country.BTN]: '🇧🇹',
  [Country.BVT]: '🇧🇻',
  [Country.BWA]: '🇧🇼',
  [Country.CAF]: '🇨🇫',
  [Country.CAN]: '🇨🇦',
  [Country.CCK]: '🇨🇨',
  [Country.CHE]: '🇨🇭',
  [Country.CHL]: '🇨🇱',
  [Country.CHN]: '🇨🇳',
  [Country.CIV]: '🇨🇮',
  [Country.CMR]: '🇨🇲',
  [Country.COD]: '🇨🇩',
  [Country.COG]: '🇨🇬',
  [Country.COK]: '🇨🇰',
  [Country.COL]: '🇨🇴',
  [Country.COM]: '🇰🇲',
  [Country.CPV]: '🇨🇻',
  [Country.CRI]: '🇨🇷',
  [Country.CUB]: '🇨🇺',
  [Country.CUW]: '🇨🇼',
  [Country.CXR]: '🇨🇽',
  [Country.CYM]: '🇰🇾',
  [Country.CYP]: '🇨🇾',
  [Country.CZE]: '🇨🇿',
  [Country.DEU]: '🇩🇪',
  [Country.DJI]: '🇩🇯',
  [Country.DMA]: '🇩🇲',
  [Country.DNK]: '🇩🇰',
  [Country.DOM]: '🇩🇴',
  [Country.DZA]: '🇩🇿',
  [Country.ECU]: '🇪🇨',
  [Country.EGY]: '🇪🇬',
  [Country.ERI]: '🇪🇷',
  [Country.ESH]: '🇪🇭',
  [Country.ESP]: '🇪🇸',
  [Country.EST]: '🇪🇪',
  [Country.ETH]: '🇪🇹',
  [Country.FIN]: '🇫🇮',
  [Country.FJI]: '🇫🇯',
  [Country.FLK]: '🇫🇰',
  [Country.FRA]: '🇫🇷',
  [Country.FRO]: '🇫🇴',
  [Country.FSM]: '🇫🇲',
  [Country.GAB]: '🇬🇦',
  [Country.GBR]: '🇬🇧',
  [Country.GEO]: '🇬🇪',
  [Country.GGY]: '🇬🇬',
  [Country.GHA]: '🇬🇭',
  [Country.GIB]: '🇬🇮',
  [Country.GIN]: '🇬🇳',
  [Country.GLP]: '🇬🇵',
  [Country.GMB]: '🇬🇲',
  [Country.GNB]: '🇬🇼',
  [Country.GNQ]: '🇬🇶',
  [Country.GRC]: '🇬🇷',
  [Country.GRD]: '🇬🇩',
  [Country.GRL]: '🇬🇱',
  [Country.GTM]: '🇬🇹',
  [Country.GUF]: '🇬🇫',
  [Country.GUM]: '🇬🇺',
  [Country.GUY]: '🇬🇾',
  [Country.HKG]: '🇭🇰',
  [Country.HMD]: '🇭🇲',
  [Country.HND]: '🇭🇳',
  [Country.HRV]: '🇭🇷',
  [Country.HTI]: '🇭🇹',
  [Country.HUN]: '🇭🇺',
  [Country.IDN]: '🇮🇩',
  [Country.IMN]: '🇮🇲',
  [Country.IND]: '🇮🇳',
  [Country.IOT]: '🇮🇴',
  [Country.IRL]: '🇮🇪',
  [Country.IRN]: '🇮🇷',
  [Country.IRQ]: '🇮🇶',
  [Country.ISL]: '🇮🇸',
  [Country.ISR]: '🇮🇱',
  [Country.ITA]: '🇮🇹',
  [Country.JAM]: '🇯🇲',
  [Country.JEY]: '🇯🇪',
  [Country.JOR]: '🇯🇴',
  [Country.JPN]: '🇯🇵',
  [Country.KAZ]: '🇰🇿',
  [Country.KEN]: '🇰🇪',
  [Country.KGZ]: '🇰🇬',
  [Country.KHM]: '🇰🇭',
  [Country.KIR]: '🇰🇮',
  [Country.KNA]: '🇰🇳',
  [Country.KOR]: '🇰🇷',
  [Country.KWT]: '🇰🇼',
  [Country.LAO]: '🇱🇦',
  [Country.LBN]: '🇱🇧',
  [Country.LBR]: '🇱🇷',
  [Country.LBY]: '🇱🇾',
  [Country.LCA]: '🇱🇨',
  [Country.LIE]: '🇱🇮',
  [Country.LKA]: '🇱🇰',
  [Country.LSO]: '🇱🇸',
  [Country.LTU]: '🇱🇹',
  [Country.LUX]: '🇱🇺',
  [Country.LVA]: '🇱🇻',
  [Country.MAC]: '🇲🇴',
  [Country.MAF]: '🇲🇫',
  [Country.MAR]: '🇲🇦',
  [Country.MCO]: '🇲🇨',
  [Country.MDA]: '🇲🇩',
  [Country.MDG]: '🇲🇬',
  [Country.MDV]: '🇲🇻',
  [Country.MEX]: '🇲🇽',
  [Country.MHL]: '🇲🇭',
  [Country.MKD]: '🇲🇰',
  [Country.MLI]: '🇲🇱',
  [Country.MLT]: '🇲🇹',
  [Country.MMR]: '🇲🇲',
  [Country.MNE]: '🇲🇪',
  [Country.MNG]: '🇲🇳',
  [Country.MNP]: '🇲🇵',
  [Country.MOZ]: '🇲🇿',
  [Country.MRT]: '🇲🇷',
  [Country.MSR]: '🇲🇸',
  [Country.MTQ]: '🇲🇶',
  [Country.MUS]: '🇲🇺',
  [Country.MWI]: '🇲🇼',
  [Country.MYS]: '🇲🇾',
  [Country.MYT]: '🇾🇹',
  [Country.NAM]: '🇳🇦',
  [Country.NCL]: '🇳🇨',
  [Country.NER]: '🇳🇪',
  [Country.NFK]: '🇳🇫',
  [Country.NGA]: '🇳🇬',
  [Country.NIC]: '🇳🇮',
  [Country.NIU]: '🇳🇺',
  [Country.NLD]: '🇳🇱',
  [Country.NOR]: '🇳🇴',
  [Country.NPL]: '🇳🇵',
  [Country.NRU]: '🇳🇷',
  [Country.NZL]: '🇳🇿',
  [Country.OMN]: '🇴🇲',
  [Country.PAK]: '🇵🇰',
  [Country.PAN]: '🇵🇦',
  [Country.PCN]: '🇵🇳',
  [Country.PER]: '🇵🇪',
  [Country.PHL]: '🇵🇭',
  [Country.PLW]: '🇵🇼',
  [Country.PNG]: '🇵🇬',
  [Country.POL]: '🇵🇱',
  [Country.PRI]: '🇵🇷',
  [Country.PRK]: '🇰🇵',
  [Country.PRT]: '🇵🇹',
  [Country.PRY]: '🇵🇾',
  [Country.PSE]: '🇵🇸',
  [Country.PYF]: '🇵🇫',
  [Country.QAT]: '🇶🇦',
  [Country.REU]: '🇷🇪',
  [Country.ROU]: '🇷🇴',
  [Country.RUS]: '🇷🇺',
  [Country.RWA]: '🇷🇼',
  [Country.SAU]: '🇸🇦',
  [Country.SDN]: '🇸🇩',
  [Country.SEN]: '🇸🇳',
  [Country.SGP]: '🇸🇬',
  [Country.SGS]: '🇬🇸',
  [Country.SHN]: '🇸🇭',
  [Country.SJM]: '🇸🇯',
  [Country.SLB]: '🇸🇧',
  [Country.SLE]: '🇸🇱',
  [Country.SLV]: '🇸🇻',
  [Country.SMR]: '🇸🇲',
  [Country.SOM]: '🇸🇴',
  [Country.SPM]: '🇵🇲',
  [Country.SRB]: '🇷🇸',
  [Country.SSD]: '🇸🇸',
  [Country.STP]: '🇸🇹',
  [Country.SUR]: '🇸🇷',
  [Country.SVK]: '🇸🇰',
  [Country.SVN]: '🇸🇮',
  [Country.SWE]: '🇸🇪',
  [Country.SXM]: '🇸🇽',
  [Country.SYC]: '🇸🇨',
  [Country.SYR]: '🇸🇾',
  [Country.TCA]: '🇹🇨',
  [Country.TCD]: '🇹🇩',
  [Country.TGO]: '🇹🇬',
  [Country.THA]: '🇹🇭',
  [Country.TJK]: '🇹🇯',
  [Country.TKL]: '🇹🇰',
  [Country.TKM]: '🇹🇲',
  [Country.TLS]: '🇹🇱',
  [Country.TON]: '🇹🇴',
  [Country.TTO]: '🇹🇹',
  [Country.TUN]: '🇹🇳',
  [Country.TUR]: '🇹🇷',
  [Country.TUV]: '🇹🇻',
  [Country.TWN]: '🇹🇼',
  [Country.TZA]: '🇹🇿',
  [Country.UGA]: '🇺🇬',
  [Country.UKR]: '🇺🇦',
  [Country.UMI]: '🇺🇲',
  [Country.URY]: '🇺🇾',
  [Country.USA]: '🇺🇸',
  [Country.UZB]: '🇺🇿',
  [Country.VAT]: '🇻🇦',
  [Country.VCT]: '🇻🇨',
  [Country.VEN]: '🇻🇪',
  [Country.VGB]: '🇻🇬',
  [Country.VIR]: '🇻🇮',
  [Country.VNM]: '🇻🇳',
  [Country.VUT]: '🇻🇺',
  [Country.WLF]: '🇼🇫',
  [Country.WSM]: '🇼🇸',
  [Country.YEM]: '🇾🇪',
  [Country.ZAF]: '🇿🇦',
  [Country.ZMB]: '🇿🇲',
  [Country.ZWE]: '🇿🇼',
  [Country.Unknown]: '🌐',
});
